import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import * as THREE from "three";
import { useMapStore } from "../../store/useMapStore.js";
import * as BufferGeometryUtils from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { mercatorRelative } from "../../services/MercatorRelativeToCenter.js";
import { useSiteExportStore } from "../../store/useSiteExport.js";
import { geometryToJSON } from "../../utils/GeometryHelper.js";
//import { useBackgroundclickstore } from "../../store/useUifunctionaitystore.js";
import { useEntityStore } from "../../store/useExportStore.js";
import GUI from "lil-gui";
import { Stage, GeometryType } from "../../constants/progress.js";
import { useProgressStore } from "../../store/progressStore.js";
import { useGeometrySelectionStore } from "../../store/useGeometrySelectionStore.js";


const MultiPolygonPlane = ({ 
  entities, 
  scalingFactor, 
  selectedEntityId, 
  setSelectedEntityId,
  inputVisibilty,
  onEntitySelect,
  className,
  topographyVisibilty
}) => {
  const updateProgress = useProgressStore.getState().updateProgress;
  const geometryType = GeometryType.BUILDINGS;
  const [mesh, setMesh] = useState(false); 
  const [wallopacity, setwallOpacity] = useState(1.0);
  const [roofopacity, setroofOpacity] = useState(1.0);
  const [wallColor, setWallColor] = useState("#FEFEFE");
  const [roofColor, setRoofColor] = useState("#a96364");
  const zoom = useMapStore(state => state.zoom);
  const groundRoofMeshRef = useRef();
  const groundMeshRef = useRef();
  const roofMeshRef = useRef();
  const projectedgroundMeshRef = useRef();
  const projectedRoofMeshRef = useRef();
  const wallMeshRef = useRef();
  const projectedGroundRoofMeshRef = useRef();
  const projectedWallMeshRef = useRef();
  const setBuildingEntity = useEntityStore((state) => state.setBuildingEntity);
  const clearBuilding = useEntityStore((state) => state.clearBuilding);
  const setBuildingEntities = useSiteExportStore((state) => state.setBuildingEntity);
  const setProjectedBuildingEntities = useSiteExportStore((state)=> state.setProjectedBuildingEntity)
  const { selectBuilding, isBuildingSelected, selectedType } = useGeometrySelectionStore();

  const {
    groundRoofMergedGeometries, 
    groundMergedGeometries,
    roofMergedGeometries,
    wallMergedGeometries,
    projectedGroundRoofMergedGeometries,
    projectedWallMergedGeometries,
    groundRoofEntityIndices,
    groundEntityIndices,
    roofEntityIndices,
    wallEntityIndices,
    projectedGroundRoofEntityIndices,
    projectedWallEntityIndices,
    groundRoofVertexToEntity,
    groundVertexToEntity,
    roofVertexToEntity,
    groundVertexIndices,
    roofVertexIndices,
    wallVertexToEntity,
    projectedGroundRoofVertexToEntity,
    projectedWallVertexToEntity,
    buildings,
    projectedbuildings,
    projectedRoofEntityIndices,
    projectedGroundEntityIndices,
    projectedGroundVertexToEntity,
    projectedRoofVertexToEntity,
    projectedRoofMergedGeometries,
    projectedGroundMergedGeometries,


  } = useMemo(() => {
    let groundRoofMergedGeometries = null;
    let wallMergedGeometries = null;
    let projectedGroundRoofMergedGeometries = null;
    let projectedWallMergedGeometries = null;
    let projectedRoofMergedGeometries = null;
    let projectedGroundMergedGeometries = null;
    const groundGeometries = [];


    let groundMergedGeometries = null;

    const roofGeometries = [];
    let roofMergedGeometries = null;

    const groundRoofGeometries = [];
    const wallGeometries = [];
    const projectedGroundRoofGeometries = [];

    const projectedRoofGeometries = [];
    const projectedGroundGeometries = [];
    const projectedWallGeometries = [];

    const groundEntityIndices = [];
    const roofEntityIndices = [];

    const groundRoofEntityIndices = [];
    const wallEntityIndices = [];
    const projectedGroundRoofEntityIndices = [];
    const projectedWallEntityIndices = [];

    const projectedGroundEntityIndices = [];
    const projectedRoofEntityIndices = [];
    
    const groundVertexIndices = [];
    const roofVertexIndices = [];
    const groundRoofVertexIndices = [];
    const wallVertexIndices = [];
    const projectedGroundRoofVertexIndices = [];
    const projectedWallVertexIndices = [];
    const projectedGroundVertexIndices = [];
    const projectedRoofVertexIndices = [];
    
    const buildings = [];
    const projectedbuildings = [];
   
    updateProgress(geometryType,{
      stage: Stage.CREATE,
      message:'Create geometries',
      progress: 75,
      error: null
    });

    entities.forEach((entity, entityIndex) => {
      const buildingSurfaces = {
        buildingProperties: {
          area: entity.area,
          buildingHeight: entity.measuredheight,
          buildingFunction: entity.buildingFunction,
          muncipalityName: entity.muncipalityName,
          objectId: entity.objectId,
          objectType: entity.objectType,
          roofShape: entity.roofShape,
          volume: entity.volume,
          lod: entity.lod,
          surfaces: entity.surfaces
        },
        surfaces: {
          ground: [],
          walls: [],
          roofs: []
        }
      };

      const projectedBuildingSurfaces = {
        buildingProperties: {
          area: entity.area,
          buildingHeight: entity.measuredheight,
          buildingFunction: entity.buildingFunction,
          muncipalityName: entity.muncipalityName,
          objectId: entity.objectId,
          objectType: entity.objectType,
          roofShape: entity.roofShape,
          volume: entity.volume,
          lod: entity.lod,
          surfaces: entity.surfaces
        },
        surfaces: {
          ground: [],
          walls: [],
          roofs: []
        }
      };
      
      // Process regular surfaces
      if (Array.isArray(entity.surfaces) && entity.surfaces.length > 0) {
        entity.surfaces.forEach((surface, surfaceIndex) => {
          try {
            const mercatorRelativeToCenter = surface.geometry.coordinates;
            const coords = mercatorRelativeToCenter.flat(); 
            const uniqueCoords = coords.slice(0, -1);        
            
            if (uniqueCoords.length < 3) {
              console.warn('Skipping surface - insufficient vertices');
              return;
            }
            let extrusionHeight = 0;
            let geometry = null;
            const isBremen = entity.muncipalityName === "Bremen";
            const effectiveLod = isBremen ? 1 : entity.lod;
            if(effectiveLod == 1)
            {
              extrusionHeight = entity.measuredheight;
            }
            if (surface.objectType === "GroundSurface" || surface.objectType === "RoofSurface") {
            
              geometry = createPlanarSurface(uniqueCoords, surface.objectType, surfaceIndex, extrusionHeight);
              if (geometry) {
                  
                  if (surface.objectType === "GroundSurface") { 
                      const groundSurface = geometryToJSON(geometry);
                      buildingSurfaces.surfaces.ground.push(groundSurface);
                      const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                      for (let i = 0; i < faceCount; i++) {
                        groundEntityIndices.push(entityIndex);
                      }
                      const vertexCount = geometry.attributes.position.count;
                      for (let i = 0; i < vertexCount; i++) {
                        groundVertexIndices.push(entityIndex);
                      }
                      groundGeometries.push(geometry);
                    }
                  if (surface.objectType === "RoofSurface") { 
                      const roofSurface = geometryToJSON(geometry);
                      buildingSurfaces.surfaces.roofs.push(roofSurface);
                      const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                      for (let i = 0; i < faceCount; i++) {
                        roofEntityIndices.push(entityIndex);
                      }
                      const vertexCount = geometry.attributes.position.count;
                      for (let i = 0; i < vertexCount; i++) {
                        roofVertexIndices.push(entityIndex);
                      }  
                      roofGeometries.push(geometry)
                    }
                  }

            } else if (surface.objectType === "WallSurface" || surface.objectType === "ClosureSurface") {
              
              // Skip wall surfaces for Bremen — LOD1 extrusion already covers the full building volume
              if(!isBremen && effectiveLod == 2)
              {
                  geometry = createWallSurface(uniqueCoords, surface.objectType, surfaceIndex);
                  if (geometry) {
                    wallGeometries.push(geometry);
                    if (surface.objectType === "WallSurface" || surface.objectType === "ClosureSurface") { 
                      const wallSurface = geometryToJSON(geometry);
                      buildingSurfaces.surfaces.walls.push(wallSurface);
                    }
                    
                    const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                    for (let i = 0; i < faceCount; i++) {
                      wallEntityIndices.push(entityIndex);
                    }
                    const vertexCount = geometry.attributes.position.count;
                    for (let i = 0; i < vertexCount; i++) {
                      wallVertexIndices.push(entityIndex);
                    }
                  }
              }
            }
          } catch (error) {
            console.error(`Error creating geometry for ${surface.objectType}:`, error);
          }
        });
      }
      
      // Process projected surfaces -------------------------------------------------------------------------------------------------------

      if (Array.isArray(entity.projectedsurfaces) && entity.projectedsurfaces.length > 0) {
        entity.projectedsurfaces.forEach((surface, surfaceIndex) => {
          try {
            const mercatorRelativeToCenter = surface.geometry.coordinates;
            const coords = mercatorRelativeToCenter.flat(); 
            const uniqueCoords = coords.slice(0, -1);        
            
            if (uniqueCoords.length < 3) {
              console.warn('Skipping projected surface - insufficient vertices');
              return;
            }
              
            let extrusionHeight = 0;
            const isBremen = entity.muncipalityName === "Bremen";
            const effectiveLod = isBremen ? 1 : entity.lod;
            if(effectiveLod == 1)
            {
              extrusionHeight = entity.measuredheight;
            }
            let geometry = null;
            if (surface.objectType === "GroundSurface" || surface.objectType === "RoofSurface") {
              geometry = createPlanarSurface(uniqueCoords, surface.objectType, surfaceIndex, extrusionHeight);
              if (geometry) {
               // projectedGroundRoofGeometries.push(geometry);
                const groundSurface = geometryToJSON(geometry);
                 if (surface.objectType === "GroundSurface" ){
                      const groundSurface = geometryToJSON(geometry);
                      const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                      for (let i = 0; i < faceCount; i++) {
                        projectedGroundEntityIndices.push(entityIndex);
                      }
                      
                      const vertexCount = geometry.attributes.position.count;
                      for (let i = 0; i < vertexCount; i++) {
                        projectedGroundVertexIndices.push(entityIndex);
                      }
                      projectedGroundGeometries.push(geometry);
                      projectedBuildingSurfaces.surfaces.ground.push(groundSurface);
                      //console.log("Projected ground surface", projectedGroundGeometries)
                 }

                  if (surface.objectType === "RoofSurface" ){
                    const roofSurface = geometryToJSON(geometry);
                    projectedBuildingSurfaces.surfaces.roofs.push(roofSurface);
                    const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                    for (let i = 0; i < faceCount; i++) {
                      projectedRoofEntityIndices.push(entityIndex);
                    }
                    
                    const vertexCount = geometry.attributes.position.count;
                    for (let i = 0; i < vertexCount; i++) {
                      projectedRoofVertexIndices.push(entityIndex);
                    }
                    projectedRoofGeometries.push(geometry);
                    //console.log("Projected roof surface", projectedRoofGeometries)
                 }
              
              
              }
            } else if (surface.objectType === "WallSurface" || surface.objectType === "ClosureSurface") {

              // Skip wall surfaces for Bremen — LOD1 extrusion already covers the full building volume
              if(!isBremen && effectiveLod == 2)
              {
                  geometry = createWallSurface(uniqueCoords, surface.objectType, surfaceIndex);
              
              if (geometry) {
                  projectedWallGeometries.push(geometry);
                  const wallSurface = geometryToJSON(geometry);
                  projectedBuildingSurfaces.surfaces.walls.push(wallSurface);
                  const faceCount = geometry.index ? geometry.index.count / 3 : geometry.attributes.position.count / 3;
                  for (let i = 0; i < faceCount; i++) {
                    projectedWallEntityIndices.push(entityIndex);
                  }
                  const vertexCount = geometry.attributes.position.count;
                  for (let i = 0; i < vertexCount; i++) {
                    projectedWallVertexIndices.push(entityIndex);
                  }
                }
              }
            
              
            }
          } catch (error) {
            console.error(`Error creating projected geometry for ${surface.objectType}:`, error);
          }
        });
      }
      
      buildings.push(buildingSurfaces);
      projectedbuildings.push(projectedBuildingSurfaces);
    });
  
    // Merge regular geometries — each type is independent so Bremen (ground-only) doesn't block the others
    if (groundGeometries.length > 0 || roofGeometries.length > 0 || wallGeometries.length > 0) {
      updateProgress(geometryType, {
        stage: Stage.CREATED,
        message: 'Create geometries completed',
        created: buildings.length,
        progress: 100
      });

      if (groundGeometries.length > 0) {
        groundMergedGeometries = BufferGeometryUtils.mergeGeometries(groundGeometries, false);
        groundMergedGeometries.computeBoundingBox();
        groundMergedGeometries.computeBoundingSphere();

        const grPositionCount = groundMergedGeometries.attributes.position.count;
        const grColors = new Float32Array(grPositionCount * 3);
        const baseGroundColor = new THREE.Color(wallColor);
        for (let i = 0; i < grPositionCount; i++) {
          grColors[i * 3]     = baseGroundColor.r;
          grColors[i * 3 + 1] = baseGroundColor.g;
          grColors[i * 3 + 2] = baseGroundColor.b;
        }
        groundMergedGeometries.setAttribute('color', new THREE.BufferAttribute(grColors, 3));
      }

      if (roofGeometries.length > 0) {
        roofMergedGeometries = BufferGeometryUtils.mergeGeometries(roofGeometries, false);
        roofMergedGeometries.computeBoundingBox();
        roofMergedGeometries.computeBoundingSphere();

        const rfPositionCount = roofMergedGeometries.attributes.position.count;
        const rfColors = new Float32Array(rfPositionCount * 3);
        const baseRoofColor = new THREE.Color(roofColor);
        for (let i = 0; i < rfPositionCount; i++) {
          rfColors[i * 3]     = baseRoofColor.r;
          rfColors[i * 3 + 1] = baseRoofColor.g;
          rfColors[i * 3 + 2] = baseRoofColor.b;
        }
        roofMergedGeometries.setAttribute('color', new THREE.BufferAttribute(rfColors, 3));
      }

      if (wallGeometries.length > 0) {
        wallMergedGeometries = BufferGeometryUtils.mergeGeometries(wallGeometries, false);
        wallMergedGeometries.computeBoundingBox();
        wallMergedGeometries.computeBoundingSphere();

        const wallPositionCount = wallMergedGeometries.attributes.position.count;
        const wallColors = new Float32Array(wallPositionCount * 3);
        const baseWallColor = new THREE.Color("#FEFEFE");
        for (let i = 0; i < wallPositionCount; i++) {
          wallColors[i * 3]     = baseWallColor.r;
          wallColors[i * 3 + 1] = baseWallColor.g;
          wallColors[i * 3 + 2] = baseWallColor.b;
        }
        wallMergedGeometries.setAttribute('color', new THREE.BufferAttribute(wallColors, 3));
      }
      // console.log(" wall ", wallMergedGeometries)
      // console.log(" ground surface ", groundMergedGeometries)
      // console.log(" roof surface ", roofMergedGeometries)

    }

    // Merge projected geometries --------------------------------------------------------------------------------------------------------------------------
    // console.log("Projected wall ", projectedWallGeometries)
    // console.log("Projected ground surface ", projectedGroundGeometries)
    // console.log("Projected roof surface ", projectedRoofGeometries)

    if (projectedGroundGeometries.length > 0 || projectedRoofGeometries.length > 0 || projectedWallGeometries.length > 0) {

      if (projectedGroundGeometries.length > 0) {
        projectedGroundMergedGeometries = BufferGeometryUtils.mergeGeometries(projectedGroundGeometries, false);
        projectedGroundMergedGeometries.computeBoundingBox();
        projectedGroundMergedGeometries.computeBoundingSphere();

        const grPositionCount = projectedGroundMergedGeometries.attributes.position.count;
        const grColors = new Float32Array(grPositionCount * 3);
        const baseGroundColor = new THREE.Color(wallColor);
        for (let i = 0; i < grPositionCount; i++) {
          grColors[i * 3]     = baseGroundColor.r;
          grColors[i * 3 + 1] = baseGroundColor.g;
          grColors[i * 3 + 2] = baseGroundColor.b;
        }
        projectedGroundMergedGeometries.setAttribute('color', new THREE.BufferAttribute(grColors, 3));
      }

      if (projectedRoofGeometries.length > 0) {
        projectedRoofMergedGeometries = BufferGeometryUtils.mergeGeometries(projectedRoofGeometries, false);
        projectedRoofMergedGeometries.computeBoundingBox();
        projectedRoofMergedGeometries.computeBoundingSphere();

        const rfPositionCount = projectedRoofMergedGeometries.attributes.position.count;
        const rfColors = new Float32Array(rfPositionCount * 3);
        const baseRoofColor = new THREE.Color(roofColor);
        for (let i = 0; i < rfPositionCount; i++) {
          rfColors[i * 3]     = baseRoofColor.r;
          rfColors[i * 3 + 1] = baseRoofColor.g;
          rfColors[i * 3 + 2] = baseRoofColor.b;
        }
        projectedRoofMergedGeometries.setAttribute('color', new THREE.BufferAttribute(rfColors, 3));
      }

      if (projectedWallGeometries.length > 0) {
        projectedWallMergedGeometries = BufferGeometryUtils.mergeGeometries(projectedWallGeometries, false);
        projectedWallMergedGeometries.computeBoundingBox();
        projectedWallMergedGeometries.computeBoundingSphere();

        const wallPositionCount = projectedWallMergedGeometries.attributes.position.count;
        const wallColors = new Float32Array(wallPositionCount * 3);
        const baseWallColor = new THREE.Color("#FEFEFE");
        for (let i = 0; i < wallPositionCount; i++) {
          wallColors[i * 3]     = baseWallColor.r;
          wallColors[i * 3 + 1] = baseWallColor.g;
          wallColors[i * 3 + 2] = baseWallColor.b;
        }
        projectedWallMergedGeometries.setAttribute('color', new THREE.BufferAttribute(wallColors, 3));
      }
    }
    //---------------------------------------------------------------------end--------------------------------------------------------------------------
    if (wallGeometries.length === 0 && groundGeometries.length === 0 && roofGeometries.length ===0 &&
        projectedWallGeometries.length === 0 && projectedGroundGeometries.length === 0 && projectedRoofGeometries.length === 0 ) {
          console.log("Buildings error")
      updateProgress(geometryType,{
        stage: Stage.ERROR,
        message: 'Error creating building geometries',
        created: 0,
        progress: 0
      });
    }
    else{
       updateProgress(geometryType,{
        stage: Stage.DONE,
        message: 'Error creating building geometries',
        created: 0,
        progress: 0
      });

    }
    
    return {
      groundMergedGeometries,
      roofMergedGeometries,
      groundRoofMergedGeometries,
      wallMergedGeometries,
      projectedGroundRoofMergedGeometries,
      projectedWallMergedGeometries,
      groundRoofEntityIndices,
      wallEntityIndices,
      projectedGroundRoofEntityIndices,
      projectedWallEntityIndices,
      groundVertexIndices,
      roofVertexIndices,
      groundEntityIndices,
      roofEntityIndices,
      groundVertexToEntity: groundVertexIndices,
      roofVertexToEntity: roofVertexIndices,
      groundRoofVertexToEntity: groundRoofVertexIndices,
      wallVertexToEntity: wallVertexIndices,
      projectedGroundVertexToEntity: projectedGroundVertexIndices,
      projectedRoofVertexToEntity: projectedRoofVertexIndices,
      projectedGroundRoofVertexToEntity: projectedGroundRoofVertexIndices,
      projectedWallVertexToEntity: projectedWallVertexIndices,
      buildings,
      projectedbuildings,
      projectedRoofMergedGeometries,
      projectedGroundMergedGeometries,
      projectedRoofEntityIndices,
      projectedGroundEntityIndices,

    };
  }, [entities, topographyVisibilty]);

  // Get active geometries based on topography visibility
  //const activeGroundRoofGeometry = topographyVisibilty ? groundRoofMergedGeometries : projectedGroundRoofMergedGeometries;
  const activeGroundGeometry = topographyVisibilty ? groundMergedGeometries : projectedGroundMergedGeometries;
  const activeRoofGeometry = topographyVisibilty ? roofMergedGeometries : projectedRoofMergedGeometries;
  const activeWallGeometry = topographyVisibilty ? wallMergedGeometries : projectedWallMergedGeometries;
  //const activeGroundRoofEntityIndices = topographyVisibilty ? groundRoofEntityIndices : projectedGroundRoofEntityIndices;
  const activeGroundEntityIndices = topographyVisibilty ? groundEntityIndices : projectedGroundEntityIndices;
  const activeRoofEntityIndices = topographyVisibilty ? roofEntityIndices : projectedRoofEntityIndices;
  const activeWallEntityIndices = topographyVisibilty ? wallEntityIndices : projectedWallEntityIndices;
 // const activeGroundRoofVertexToEntity = topographyVisibilty ? groundRoofVertexToEntity : projectedGroundRoofVertexToEntity;
  const activeWallVertexToEntity = topographyVisibilty ? wallVertexToEntity : projectedWallVertexToEntity;
  const activeGroundVertexToEntity = topographyVisibilty ? groundVertexToEntity : projectedGroundVertexToEntity;
  const activeRoofVertexToEntity = topographyVisibilty ? roofVertexToEntity : projectedRoofVertexToEntity;

  // Debug: Log when topography visibility changes
  // useEffect(() => {
  //   console.log('Topography Visibility Changed:', topographyVisibilty);
  //   console.log('Regular surfaces exist:', !!groundRoofMergedGeometries, !!wallMergedGeometries);
  //   console.log('Projected surfaces exist:', !!projectedGroundRoofMergedGeometries, !!projectedWallMergedGeometries);
  //   console.log('Active geometries:', !!activeGroundGeometry, !!activeWallGeometry);
  // }, [topographyVisibilty, groundRoofMergedGeometries, wallMergedGeometries, projectedGroundRoofMergedGeometries, projectedWallMergedGeometries, activeGroundGeometry, activeWallGeometry]);

  // Reset colors when selection is cleared (background or other geometry clicked)
  useEffect(() => {
    // console.log("Active Geometries ground ",activeGroundGeometry )
    // console.log("Active Geometries wall ",activeWallGeometry )
    // console.log("Active Geometries roof ",activeRoofGeometry )
    if (!activeGroundGeometry && !activeWallGeometry && !activeRoofGeometry) return;
    
    // If no building is selected (background clicked or other geometry selected)
    if (selectedType !== 'building') {
      // Reset ground colors
      if (activeGroundGeometry && activeGroundGeometry.attributes.color) {
        const grPositionCount = activeGroundGeometry.attributes.position.count;
        const grColors = activeGroundGeometry.attributes.color.array;
        const baseGroundColor = new THREE.Color(wallColor);
        
        for (let i = 0; i < grPositionCount; i++) {
          grColors[i * 3] = baseGroundColor.r;
          grColors[i * 3 + 1] = baseGroundColor.g;
          grColors[i * 3 + 2] = baseGroundColor.b;
        }
        activeGroundGeometry.attributes.color.needsUpdate = true;
      }

      // Reset roof colors
      if (activeRoofGeometry && activeRoofGeometry.attributes.color) {
        const rfPositionCount = activeRoofGeometry.attributes.position.count;
        const rfColors = activeRoofGeometry.attributes.color.array;
        const baseRoofColor = new THREE.Color(roofColor);
        
        for (let i = 0; i < rfPositionCount; i++) {
          rfColors[i * 3] = baseRoofColor.r;
          rfColors[i * 3 + 1] = baseRoofColor.g;
          rfColors[i * 3 + 2] = baseRoofColor.b;
        }
        activeRoofGeometry.attributes.color.needsUpdate = true;
      }
      
      // Reset wall colors
      if (activeWallGeometry && activeWallGeometry.attributes.color) {
        const wallPositionCount = activeWallGeometry.attributes.position.count;
        const wallColors = activeWallGeometry.attributes.color.array;
        const baseWallColor = new THREE.Color(wallColor);
        
        for (let i = 0; i < wallPositionCount; i++) {
          wallColors[i * 3] = baseWallColor.r;
          wallColors[i * 3 + 1] = baseWallColor.g;
          wallColors[i * 3 + 2] = baseWallColor.b;
        }
        activeWallGeometry.attributes.color.needsUpdate = true;
      }
      
      setSelectedEntityId(null);
    }
    // If a different building is selected, check if our current selection needs to be cleared
    else if (selectedEntityId && !isBuildingSelected(selectedEntityId)) {
      // Reset ground colors
      if (activeGroundGeometry && activeGroundGeometry.attributes.color) {
        const grPositionCount = activeGroundGeometry.attributes.position.count;
        const grColors = activeGroundGeometry.attributes.color.array;
        const baseGroundColor = new THREE.Color(wallColor);
        
        for (let i = 0; i < grPositionCount; i++) {
          grColors[i * 3] = baseGroundColor.r;
          grColors[i * 3 + 1] = baseGroundColor.g;
          grColors[i * 3 + 2] = baseGroundColor.b;
        }
        activeGroundGeometry.attributes.color.needsUpdate = true;
      }

      // Reset roof colors
      if (activeRoofGeometry && activeRoofGeometry.attributes.color) {
        const rfPositionCount = activeRoofGeometry.attributes.position.count;
        const rfColors = activeRoofGeometry.attributes.color.array;
        const baseRoofColor = new THREE.Color(roofColor);
        
        for (let i = 0; i < rfPositionCount; i++) {
          rfColors[i * 3] = baseRoofColor.r;
          rfColors[i * 3 + 1] = baseRoofColor.g;
          rfColors[i * 3 + 2] = baseRoofColor.b;
        }
        activeRoofGeometry.attributes.color.needsUpdate = true;
      }
      
      // Reset wall colors
      if (activeWallGeometry && activeWallGeometry.attributes.color) {
        const wallPositionCount = activeWallGeometry.attributes.position.count;
        const wallColors = activeWallGeometry.attributes.color.array;
        const baseWallColor = new THREE.Color(wallColor);
        
        for (let i = 0; i < wallPositionCount; i++) {
          wallColors[i * 3] = baseWallColor.r;
          wallColors[i * 3 + 1] = baseWallColor.g;
          wallColors[i * 3 + 2] = baseWallColor.b;
        }
        activeWallGeometry.attributes.color.needsUpdate = true;
      }
      
      setSelectedEntityId(null);
    }
  }, [selectedType, selectedEntityId, isBuildingSelected, activeGroundGeometry, activeRoofGeometry, activeWallGeometry, roofColor, wallColor, setSelectedEntityId]);

  const handleClick = useCallback((event) => {
  
    if (!inputVisibilty) {
      console.log('Layer not visible, ignoring click');
      return;
    }
  
    event.stopPropagation();
    const intersects = event.intersections;
    
    if (intersects && intersects.length > 0) {
      const intersection = intersects[0];
      const clickedObject = intersection.object;
      const faceIndex = intersection.faceIndex;
      
      const activeGroundMeshRef = topographyVisibilty ? groundMeshRef : projectedgroundMeshRef;
      const activeRoofMeshRef = topographyVisibilty ? roofMeshRef : projectedRoofMeshRef;
      const activeWallMeshRef = topographyVisibilty ? wallMeshRef : projectedWallMeshRef;

      // Determine which surface type was clicked and resolve the shared entity index
      let resolvedEntityIndex = undefined;

      if (clickedObject === activeGroundMeshRef.current) {
        resolvedEntityIndex = activeGroundEntityIndices[faceIndex];
      } else if (clickedObject === activeRoofMeshRef.current) {
        resolvedEntityIndex = activeRoofEntityIndices[faceIndex];
      } else if (clickedObject === activeWallMeshRef.current) {
        resolvedEntityIndex = activeWallEntityIndices[faceIndex];
      }
 
      if (resolvedEntityIndex !== undefined) {
        const selectedEntity = entities[resolvedEntityIndex];

        if (selectedEntity) {
          onEntitySelect(selectedEntity);
          console.log('Selected building:', selectedEntity);
          console.log('Selected entity index:', resolvedEntityIndex);
        
          if (!className || selectedEntity.Name === className) {
            // Get entity ID for selection tracking
            const entityId = selectedEntity.objectId || resolvedEntityIndex;
            
            // Update store
            selectBuilding(entityId);
            setSelectedEntityId(entityId);
            
            const selectedColor = new THREE.Color('#2B323A');
            
            // Update ground colors — use activeGroundGeometry's own position count and color array
            if (activeGroundGeometry && activeGroundGeometry.attributes.color) {
              const positionCount = activeGroundGeometry.attributes.position.count;
              const colors = activeGroundGeometry.attributes.color.array;
              const baseColor = new THREE.Color(wallColor);

              for (let i = 0; i < positionCount; i++) {
                // FIX: use activeGroundVertexToEntity and compare against resolvedEntityIndex
                const isSelected = activeGroundVertexToEntity[i] === resolvedEntityIndex;
                const color = isSelected ? selectedColor : baseColor;
                colors[i * 3]     = color.r;
                colors[i * 3 + 1] = color.g;
                colors[i * 3 + 2] = color.b;
              }
              activeGroundGeometry.attributes.color.needsUpdate = true;
            }

            // Update roof colors — use activeRoofGeometry's own position count and color array
            if (activeRoofGeometry && activeRoofGeometry.attributes.color) {
              const positionCount = activeRoofGeometry.attributes.position.count; // FIX: was using activeGroundGeometry.attributes.position.count
              const colors = activeRoofGeometry.attributes.color.array;           // FIX: was using activeGroundGeometry.attributes.color.array
              const baseColor = new THREE.Color(roofColor);

              for (let i = 0; i < positionCount; i++) {
                // FIX: compare against resolvedEntityIndex (shared entity index), not a separate roofselectedEntityIndex
                const isSelected = activeRoofVertexToEntity[i] === resolvedEntityIndex;
                const color = isSelected ? selectedColor : baseColor;
                colors[i * 3]     = color.r;
                colors[i * 3 + 1] = color.g;
                colors[i * 3 + 2] = color.b;
              }
              activeRoofGeometry.attributes.color.needsUpdate = true;
            }
            
            // Update wall colors — unchanged, was already correct
            if (activeWallGeometry && activeWallGeometry.attributes.color) {
              const positionCount = activeWallGeometry.attributes.position.count;
              const colors = activeWallGeometry.attributes.color.array;
              const baseColor = new THREE.Color(wallColor);
              
              for (let i = 0; i < positionCount; i++) {
                const isSelected = activeWallVertexToEntity[i] === resolvedEntityIndex;
                const color = isSelected ? selectedColor : baseColor;
                colors[i * 3]     = color.r;
                colors[i * 3 + 1] = color.g;
                colors[i * 3 + 2] = color.b;
              }
              activeWallGeometry.attributes.color.needsUpdate = true;
            }
          }
        }
      } else {
        console.log('Face index undefined or not in entityIndices');
      }
    } else {
      console.log('No intersections found');
    }
  }, [
    entities, 
    activeGroundEntityIndices,
    activeRoofEntityIndices,
    activeWallEntityIndices, 
    activeGroundVertexToEntity,
    activeRoofVertexToEntity,
    activeWallVertexToEntity,
    onEntitySelect, 
    inputVisibilty, 
    className,
    activeGroundGeometry,
    activeRoofGeometry,
    activeWallGeometry,
    roofColor,
    wallColor,
    selectBuilding,
    setSelectedEntityId,
    topographyVisibilty
  ]);

  useEffect(() => {
  
     // console.log("Buildings to export: ", buildings)
      setBuildingEntities( buildings );
      setProjectedBuildingEntities(projectedbuildings)
  
    }, [ buildings, setBuildingEntity, clearBuilding, projectedbuildings]);

  if (!activeGroundGeometry && !activeWallGeometry) {
    return null;
  }

  return (
    <group visible={inputVisibilty} >
      {/* Regular surfaces - visible when topographyVisibilty is true */}
      {topographyVisibilty && wallMergedGeometries && (
        <mesh 
          ref={wallMeshRef} 
          geometry={wallMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            wireframe={mesh}
            transparent={true}
            opacity={wallopacity}
          />
        </mesh>
      )}
      {topographyVisibilty && groundMergedGeometries && (
        <mesh 
          ref={groundMeshRef} 
          geometry={groundMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            transparent={true}
            opacity={wallopacity}
          />
        </mesh>
      )}
      {topographyVisibilty && roofMergedGeometries && (
        <mesh 
          ref={roofMeshRef} 
          geometry={roofMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            transparent={true}
            opacity={roofopacity}
          />
        </mesh>
      )}
      
      {/* Projected surfaces - visible when topographyVisibilty is false */}
      {!topographyVisibilty && projectedWallMergedGeometries && (
        <mesh 
          ref={projectedWallMeshRef} 
          geometry={projectedWallMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            wireframe={mesh}
            transparent={true}
            opacity={wallopacity}
          />
        </mesh>
      )}
      {!topographyVisibilty && projectedGroundMergedGeometries && (
        <mesh 
          ref={projectedgroundMeshRef} 
          geometry={projectedGroundMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            transparent={true}
            opacity={wallopacity}
          />
        </mesh>
      )}
      {!topographyVisibilty && projectedRoofMergedGeometries && (
        <mesh 
          ref={projectedRoofMeshRef} 
          geometry={projectedRoofMergedGeometries} 
          onClick={handleClick}
        >
          <meshStandardMaterial 
            vertexColors={true}
            side={THREE.DoubleSide}
            transparent={true}
            opacity={roofopacity}
          />
        </mesh>
      )}
    </group>
  );
};


function ensureIndexed(geometry) {
  if (!geometry.index) {
    const vertexCount = geometry.attributes.position.count;
    const indices = new Uint32Array(vertexCount);
    for (let i = 0; i < vertexCount; i++) indices[i] = i;
    geometry.setIndex(new THREE.BufferAttribute(indices, 1));
  }
  return geometry;
}
function createPlanarSurface(uniqueCoords, surfaceType, surfaceIndex, buildingHeight) {
  // Remove the duplicate 
  const coords = uniqueCoords[uniqueCoords.length - 1][0] === uniqueCoords[0][0] &&
                 uniqueCoords[uniqueCoords.length - 1][1] === uniqueCoords[0][1]
    ? uniqueCoords.slice(0, -1)
    : uniqueCoords;

  const firstZ = coords[0][2];
  const isFlat = coords.every(coord => Math.abs(coord[2] - firstZ) < 0.001);

  if (isFlat) {
    const shape = new THREE.Shape();
    coords.forEach((coord, i) => {
      if (i === 0) {
        shape.moveTo(coord[0], coord[1]);
      } else {
        shape.lineTo(coord[0], coord[1]);
      }
    });

    let geometry;

    if (buildingHeight !== 0) {
      // Extrude the shape upward by buildingHeight
      const extrudeSettings = {
        depth: buildingHeight,
        bevelEnabled: false,
      };
      const extrudedGeometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
      const positions = extrudedGeometry.attributes.position;

      // Transform vertices: X → X, Z → Y (height), -Y → Z
      const vertices = new Float32Array(positions.count * 3);
      for (let i = 0; i < positions.count; i++) {
        vertices[i * 3]     = positions.getX(i);
        vertices[i * 3 + 1] = firstZ + positions.getZ(i); // Z (extrusion depth) becomes height offset
        vertices[i * 3 + 2] = -positions.getY(i);
      }

      geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
      geometry.setIndex(extrudedGeometry.index);
      geometry.computeVertexNormals();
      extrudedGeometry.dispose();
    

    } else {
      // Flat surface — original ShapeGeometry path
      const tempGeometry = new THREE.ShapeGeometry(shape);
      const tempPositions = tempGeometry.attributes.position;

      const vertices = new Float32Array(tempPositions.count * 3);
      for (let i = 0; i < tempPositions.count; i++) {
        vertices[i * 3]     = tempPositions.getX(i);
        vertices[i * 3 + 1] = firstZ;
        vertices[i * 3 + 2] = -tempPositions.getY(i);
      }

      geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
      geometry.setIndex(tempGeometry.index);
      geometry.computeVertexNormals();
      tempGeometry.dispose();
    }

    geometry.userData = { surfaceType, entityIndex: surfaceIndex };
    return  ensureIndexed(geometry);

  } else {
    // Sloped surfaces — extrusion not applied, original path preserved
    const geometry = new THREE.BufferGeometry();

    const vertices = new Float32Array(coords.length * 3);
    for (let i = 0; i < coords.length; i++) {
      vertices[i * 3]     = coords[i][0];
      vertices[i * 3 + 1] = coords[i][2];
      vertices[i * 3 + 2] = -coords[i][1];
    }

    const indices = [];
    for (let i = 1; i < coords.length - 1; i++) {
      indices.push(0, i, i + 1);
    }

    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    geometry.userData = { surfaceType, entityIndex: surfaceIndex };

    return geometry;
  }
}


function createWallSurface(uniqueCoords, surfaceType, surfaceIndex) {
  // Remove the duplicate closing vertex if present
  const coords = uniqueCoords[uniqueCoords.length - 1][0] === uniqueCoords[0][0] &&
                 uniqueCoords[uniqueCoords.length - 1][1] === uniqueCoords[0][1] &&
                 uniqueCoords[uniqueCoords.length - 1][2] === uniqueCoords[0][2]
    ? uniqueCoords.slice(0, -1)
    : uniqueCoords;

  if (coords.length < 3) return null;

  // Convert coordinates to vertices
  const vertices = coords.map(c => new THREE.Vector3(c[0], c[2], -c[1]));
  
  // Create vertices array
  const positionArray = new Float32Array(vertices.length * 3);
  vertices.forEach((v, i) => {
    positionArray[i * 3] = v.x;
    positionArray[i * 3 + 1] = v.y;
    positionArray[i * 3 + 2] = v.z;
  });

  // Create indices using triangle fan (works for convex polygons)
  const indices = [];
  for (let i = 1; i < vertices.length - 1; i++) {
    indices.push(0, i, i + 1);
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute("position", new THREE.BufferAttribute(positionArray, 3));
  geometry.setIndex(indices);
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();
  geometry.computeBoundingSphere();

  geometry.userData = { surfaceType, entityIndex: surfaceIndex };

  return geometry;
}

export default MultiPolygonPlane;